module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAdklEQVQ4y2NgGBTgPxpgz1iJFf8/w4CCB7kB1csO/1+/Ydn/deuX/q9ceoh0A5Yu6P7f21rxv7+t4v/KpX2kGVA+b8P/o+vb/resvQHGIHbp3A3EG7Bt26L/HUvX/29Yc+1/w+pr/9uB7G1bFw21WKCvAUMbAAClo8QWZKhzwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IC.png
// module id = 1164
// module chunks = 0